import { React } from 'Imports';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./ActionButton.scss') as {
    actionButtonGeotab: string;
    actionButtonEncompass: string;
    actionIcon: string;
    actionText: string;
};

interface ActionButtonProps {
    icon: IconDefinition;
    text: string;
    disabled?: boolean;
    onClick: () => void;
}

const ActionButton = ({ icon, text, disabled, onClick }: ActionButtonProps) => {
    return (
        <button className={isEncompass ? styles.actionButtonEncompass : styles.actionButtonGeotab} onClick={onClick} disabled={disabled}>
            <FontAwesomeIcon icon={icon} onClick={onClick} className={styles.actionIcon} />
            <span className={styles.actionText}>{text}</span>
        </button>
    );
};

export default ActionButton;
